/** @jsxImportSource @emotion/react */
import { divider, option, optionName } from '../styles/CategorySection.styles';
import CategoryMenu from 'components/lab/lab_1/point_data/category_menu/CategoryMenu';
import { Switch } from '@mui/material';
import CollapsibleSection from './CollapsibleSection';

const CategorySection = ({
    selectedCategory,
    setSelectedCategory,
    imageLayerVisible,
    onChangeVisibleHandle,
    imageLayerOpacity,
    onChangeOpacityHandle,
}) => {
    return (
        <CollapsibleSection title="카테고리" defaultExpanded={true}>
            <CategoryMenu index={0} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />

            <div css={divider}></div>

            {/* 투명도 조절 */}
            <div css={option}>
                <Switch checked={imageLayerVisible} onChange={onChangeVisibleHandle} />
                <span css={optionName}>레이어 투명도</span>
                <input
                    type="range"
                    min={0}
                    max={1}
                    step={0.01}
                    value={1 - imageLayerOpacity}
                    onChange={(e) => onChangeOpacityHandle({ target: { value: 1 - parseFloat(e.target.value) } })}
                />
                <label css={optionName}>{Math.round((1 - imageLayerOpacity) * 100)}%</label>
            </div>
        </CollapsibleSection>
    );
};

export default CategorySection;
